import { render } from "./ProblemsIcon.vue?vue&type=template&id=44b561f2"
import script from "./ProblemsIcon.vue?vue&type=script&lang=js"
export * from "./ProblemsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script